@if (noOrgsFound || loading) {
  <div class="table-responsive min-height">
    <table class="table card-table table-vcenter text-nowrap datatable h-100">
      <ng-container [ngTemplateOutlet]="tableHeader" />
      @if (loading) {
        <tbody>
          <tr>
            <td colspan="3" class="text-center">
              <div class="spinner-border"></div>
            </td>
          </tr>
        </tbody>
      }
      @if (!loading && noOrgsFound) {
        <tbody>
          <tr>
            <td colSpan="3">
              <div class="empty">
                <p class="empty-title">{{ 'admin.noData' | translate }}</p>
              </div>
            </td>
          </tr>
        </tbody>
      }
    </table>
  </div>
}

@if (!noOrgsFound && !loading) {
  <cdk-virtual-scroll-viewport itemSize="32" class="table-responsive min-height">
    <table class="table card-table table-vcenter text-nowrap datatable">
      <ng-container [ngTemplateOutlet]="tableHeader" />
      @if (!loading && !noOrgsFound) {
        <tbody>
          <tr *cdkVirtualFor="let organisation of organisations; trackBy: trackByItemId">
            <td><ngb-highlight [result]="organisation.name" [term]="searchTerm"></ngb-highlight></td>
            <td>{{ organisation.parentOrganisations.length > 0 ? organisation.parentOrganisations[0].name : '&mdash;' }}</td>
            <td><ngb-highlight [result]="organisation.organisationRef" [term]="searchTerm"></ngb-highlight></td>
          </tr>
        </tbody>
      }
    </table>
  </cdk-virtual-scroll-viewport>
}


<ng-template #tableHeader>
  <thead>
    <tr>
      <th>{{ 'admin.orgTable.headers.name' | translate }}</th>
      <th>{{ 'admin.orgTable.headers.parentOrg' | translate }}</th>
      <th>{{ 'admin.orgTable.headers.externalId' | translate }}</th>
    </tr>
  </thead>
</ng-template>